module.exports = __webpack_public_path__ + "static/media/marina.1be1eece.png";